import React from "react";
import LegalLayout, { LegalBlock } from "../components/LegalLayout";

const AGB = () => {
  return (
    <LegalLayout
      title="AGB"
      subtitle="Allgemeine Geschäftsbedingungen der ROI DES ROIS GmbH"
    >
      <LegalBlock heading="1. Geltungsbereich">
        <p>
          Diese Allgemeinen Geschäftsbedingungen gelten für alle Bestellungen,
          die Verbraucher über unseren Online-Shop bei der ROI DES ROIS GmbH
          aufgeben.
        </p>
      </LegalBlock>

      <LegalBlock heading="2. Vertragsschluss">
        <p>
          Die Darstellung der Produkte im Online-Shop stellt kein rechtlich
          bindendes Angebot dar. Durch das Absenden der Bestellung gibst du ein
          verbindliches Angebot ab. Der Kaufvertrag kommt mit unserer
          Auftragsbestätigung bzw. dem Versand der Ware zustande.
        </p>
      </LegalBlock>

      <LegalBlock heading="3. Preise und Versandkosten">
        <p>
          Alle Preise verstehen sich inklusive der gesetzlichen Mehrwertsteuer.
          Ab einem Bestellwert von 99 € liefern wir innerhalb Deutschlands
          versandkostenfrei.
        </p>
      </LegalBlock>

      <LegalBlock heading="4. Lieferung">
        <p>
          Die Lieferung erfolgt innerhalb von 2–4 Werktagen nach
          Zahlungseingang innerhalb Deutschlands. Abweichende Lieferzeiten sind
          auf der jeweiligen Produktseite angegeben.
        </p>
      </LegalBlock>

      <LegalBlock heading="5. Widerrufsrecht">
        <p>
          Als Verbraucher hast du ein 30-tägiges Rückgaberecht. Ungeöffnete und
          unbenutzte Ware kann innerhalb dieser Frist zurückgesendet werden. Die
          Einzelheiten regelt unsere Widerrufsbelehrung.
        </p>
      </LegalBlock>

      <LegalBlock heading="6. Zahlung">
        <p>
          Die Zahlung erfolgt über die im Bestellprozess angebotenen
          Zahlungsarten. Bei Zahlungsverzug behalten wir uns die Geltendmachung
          weiterer Rechte vor.
        </p>
      </LegalBlock>

      <p className="text-[#8d8779] text-sm pt-4">
        Hinweis: Dies ist eine allgemeine Vorlage. Bitte lasse die finalen AGB
        vor der Veröffentlichung rechtlich prüfen.
      </p>
    </LegalLayout>
  );
};

export default AGB;
